module.exports = __webpack_public_path__ + "static/media/26.fc819272.gif";